import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import { ssListItem } from 'app/components/global';
import editCustomTestingProceduresDialog from './dialog.editEmergencyProcedureDialog';
import controller from './emergency-procedure.controller';
import directive from './emergency-procedure.directive';

export default angular.module('app.components.advisory.bcp.emergencyProcedure', [
  bcpDataService,
  constants,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  editCustomTestingProceduresDialog,
  ssListItem,
])
  .directive('bcpEmergencyProcedure', directive)
  .controller('EmergencyProcedureController', controller)
  .name;

console.log('app.components.advisory.bcp.emergencyProcedure created');
